import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { HomeWidgetsQuery } from './HomeWidgetsQuery.graphql.ts';

export function preloadHomeWidgets({ isLicensed }: { isLicensed: boolean }) {
	if (!isLicensed) {
		return Promise.resolve();
	}

	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: HomeWidgetsQuery,
	});
}
